export const IS_EXPORT = {
  YES: 1,
  NO: 0,
};

export const REDUCE_TYPE_MAP = {
  2: '限时折扣',
  3: '拼团活动',
  5: '秒杀',
  6: '会员价',
  8: '整点秒杀',
};

export const DISCOUNT_TYPE = {
  couponAmount: '优惠券活动',
  changeAmount: '红包',
  pointsAmount: '积分',
  fullreductionAmount: '满减活动',
  voucherAmount: '兑换券套餐',
  companyDiscountAmount: '企业折扣',
};

export const INVOICE_TYPE = {
  WAIT: 0,
  ONLINE: 1,
  OFFLINE: 2,
};

export const INVOICE_STATUS_MAP = {
  [INVOICE_TYPE.WAIT]: '未开票',
  [INVOICE_TYPE.ONLINE]: '线上开票',
  [INVOICE_TYPE.OFFLINE]: '线下开票',
};

export const INVOICE_OPEN_STATUS = {
  WAIT: 0, // 未开票
  OPENING: 1, // 开票中
  INVOICED: 2, // 已开票
  DISABLED: 3, // 不可开票
  OFFLINE: 999, // 已开票（线下），服务端暂时没有这个状态，前端通过开票类型为线下开票和开票状态为已完成，组合出这个状态
};

export const INVOICE_OPEN_STATUS_MAP = {
  [INVOICE_OPEN_STATUS.WAIT]: '未开票',
  [INVOICE_OPEN_STATUS.OPENING]: '开票中',
  [INVOICE_OPEN_STATUS.INVOICED]: '已开票',
  [INVOICE_OPEN_STATUS.DISABLED]: '不可开票',
  [INVOICE_OPEN_STATUS.OFFLINE]: '已开票(线下)',
};

export const BUDGET_TYPE_MAP = {
  1: '顺手付',
  2: '关爱通余额',
  3: '福利餐',
  4: '顺丰餐卡',
  5: '顺丰丰享',
  6: '平安银行',
  7: '生日福利',
  8: '企业津贴',
  9: '福利卡',
};

export const BUDGET_TYPE_GROUP = [
  {
    label: '预充值',
    options: [
      { value: 1, text: BUDGET_TYPE_MAP[1] },
      { value: 2, text: BUDGET_TYPE_MAP[2] },
      { value: 6, text: BUDGET_TYPE_MAP[6] },
    ],
  },
  {
    label: '授信',
    options: [
      { value: 3, text: BUDGET_TYPE_MAP[3] },
      { value: 4, text: BUDGET_TYPE_MAP[4] },
      { value: 5, text: BUDGET_TYPE_MAP[5] },
      { value: 7, text: BUDGET_TYPE_MAP[7] },
      { value: 8, text: BUDGET_TYPE_MAP[8] },
      { value: 9, text: BUDGET_TYPE_MAP[9] },
    ],
  },
];

export const SETTLE_STATUS_MAP = {
  1: '待入账',
  2: '已生成',
  3: '待确认',
  4: '待付款',
  5: '付款完成',
  6: '已驳回',
  7: '不需结算',
};

export const ORDER_STATUS_MAP = {
  0: '待支付',
  1: '待接单',
  4: '已取消',
  2: '配送中',
  3: '已完成',
  5: '待退款',
  7: '待售后',
  102: '预约中',
  110: '已接单',
  401: '退款成功',
};

export const OPEN_STATUS = {
  SUCCESS: 1,
  FAIL: 2,
};

export const INVOICE_QUERY_STATUS_MAP = {
  0: '申请中',
  1: '开票成功',
  2: '开票失败',
};
